module.exports = __webpack_public_path__ + "static/media/National-Highways-India.67a78d0d.jpg";